import { z } from "zod";
import { baseSearchSchema, debugSearchSchema } from "../-search-params";

export const evaluationSearchSchema = z.object({
	...baseSearchSchema.shape,
	...debugSearchSchema.shape,
});

export type EvaluationSearch = z.infer<typeof evaluationSearchSchema>;

export const validateEvaluationSearch = (search: Record<string, unknown>): EvaluationSearch => {
	return evaluationSearchSchema.parse(search);
};
